import { Dispatch, PayloadAction, createSlice } from '@reduxjs/toolkit'

import { ProjectIdentity, RootStateTypeExtra } from '@store/types'

const projectIdentity = localStorage.getItem('projectIdentity')

const INITIAL_ASSET_OPTIONS: ProjectIdentity['assetOptions'] = {
  localImages: false,
  localVideos: false,
}

let initialState = {
  projectName: '',
  projectId: '',
  projectLabel: '',
  sessionId: [],
  lightMap: '',
  masterKey: '',
  isShowcaseMultiscreen: false,
  assetPort: '',
  assetOptions: INITIAL_ASSET_OPTIONS,
} as ProjectIdentity

if (projectIdentity) {
  initialState = JSON.parse(projectIdentity)
}

if (!initialState.assetOptions) {
  initialState.assetOptions = INITIAL_ASSET_OPTIONS
}

export const saveProjectIdentityToStorage = (data: ProjectIdentity) => {
  localStorage.setItem('projectIdentity', JSON.stringify(data))
  return data
}

const projectIdentitySlice = createSlice({
  name: 'projectIdentity',
  initialState,
  reducers: {
    setProjectIdentity: (
      state: ProjectIdentity,
      action: PayloadAction<Partial<ProjectIdentity>>
    ) => {
      const updatedData = {
        ...state,
        ...action.payload,
      }

      saveProjectIdentityToStorage(updatedData)
      return updatedData
    },
    removeProjectIdentity: (state: ProjectIdentity) => {
      localStorage.removeItem('projectIdentity')
      return {
        ...state,
        ...{
          sessionId: [],
          masterKey: '',
        },
        hideNav: [],
        assetPort: '',
        assetOptions: INITIAL_ASSET_OPTIONS,
      }
    },
  },
})

export const setProjectIdentity =
  (payload: Partial<ProjectIdentity>) =>
  (dispatch: Dispatch, getState: () => RootStateTypeExtra) => {
    const state = getState()

    if (state.appConfig.isProjectSwitchInitiated) {
      return
    }

    dispatch(projectIdentitySlice.actions.setProjectIdentity(payload))
  }

export const { removeProjectIdentity } = projectIdentitySlice.actions

export const selectProject = (state: RootStateTypeExtra) =>
  state.projectIdentity

export default projectIdentitySlice.reducer
